export class GetProductList {
  static readonly type = '[PRODUCT] Get Product';
}

export class GetProductListByProductType {
  static readonly type = '[PRODUCT] Get Product Based on Product Type';
  constructor(public productType: number) {}
}
